module.exports = __webpack_public_path__ + "assets/img/3017.78553a87.png";